
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Component, Prop, Vue } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import { NRProject, NRProjectCase } from "@/lib/model/NRXQ/candidate";
import { Model } from "@/components/editor/ckeditor5";
import gateway from "@/lib/request/gateway";

@Component({
  components: {}
})
export default class NRProjectCaseEdit extends Vue {
  @Prop() data!: any;
  @Prop() form!: any;
  @Prop({ type: Boolean, default: true }) edit!: boolean;
  @Prop({ type: Boolean, default: false }) isZhuBo!: boolean; //主播类型  有图片列表 上传视屏

  @Prop({ type: String, default: "" }) ossPrefix!: string;
  showBigImg = false;
  bigImgUrl = "";
  isVideo = false;
  uploading = false;
  uploadField = "";
  uploadFileMaxSize = 50; // 最大上传多少M
  fileTypeLimit: string[] = []; //类型限制
  percent = 0;
  showBar = false;

  getMultiInputShowArray(value: string) {
    const arr = value.split(/(,|，|。|\n|\s)/);
    for (let i = arr.length; i >= 0; i--) {
      if (!arr[i] || arr[i].length < 2) {
        arr.splice(i, 1);
      }
    }
    return arr;
  }
  openLink(link: string) {
    window.open(link);
  }

  // 图片列表
  upImg() {
    this.uploadFileMaxSize = 50;
    this.uploadField = "screenshotUrlList";
    this.fileTypeLimit = ["png", "jpg", "bmp", "jpeg"];
  }
  // 视频
  upVideo() {
    this.uploadFileMaxSize = 1000;
    this.uploadField = "outVideoUrl";
    this.fileTypeLimit = [
      "mp4",
      "MP4",
      "avi",
      "AVI",
      "mov",
      "MOV",
      "rmvb",
      "RMVB",
      "rm",
      "RM",
      "flv",
      "FLV",
      "3gp",
      "3GP"
    ];
  }
  //查看大图
  openImg(url: string, type = "") {
    this.isVideo = type === "video" ? true : false;
    this.bigImgUrl = url || "";
    this.showBigImg = true;
  }
}
